import { ApiErrorCode as E } from "@hprofits/api/common/errors";
var T = /* @__PURE__ */ ((r) => (r.UNEXPECTED = "An unexpected error occurred", r))(T || {});
const e = /* @__PURE__ */ new Set([
  E.EXPECTATION_FAILED,
  E.ENTITY_NOT_FOUND,
  E.ENTITY_ALREADY_EXISTS,
  E.ENTITY_IN_USE,
  E.FIELD_CANNOT_BE_UPDATED
]), A = {
  meta: { skipDisplayError: !0 }
};
export {
  T as ERROR_MESSAGES,
  A as SUPPRESS_ERROR_TOAST_META,
  e as TRANSPARENT_ERROR_CODES
};
//# sourceMappingURL=constants.js.map
